import { Messages1 } from 'iconsax-react';
import { Link, useLocation } from 'react-router-dom';

import { Button } from '@design-system/button';
import { cn } from '@design-system/helpers';
import { createRoute, PATHS } from '@src/core/router/paths';

/** Inbox URLs are `/:organizationSlug/conversations…`. */
function isConversationsPath(pathname: string) {
  const segments = pathname.split('/').filter(Boolean);
  return segments[1] === 'conversations';
}

/** Figma Status Bar conversations control — Messages1 Bold, beside notifications. */
export function ConversationsLauncher() {
  const { pathname } = useLocation();
  const active = isConversationsPath(pathname);

  return (
    <Button
      asChild
      variant='primaryOutline'
      size='iconLg'
      className={cn(
        'relative border-primary-200 text-gray-800',
        active && 'bg-primary-100 text-primary-1000 hover:bg-primary-100'
      )}
    >
      <Link
        to={createRoute(PATHS.CONVERSATIONS)}
        aria-label='Conversations'
        aria-current={active ? 'page' : undefined}
      >
        <Messages1
          size={24}
          variant='Bold'
          aria-hidden='true'
        />
      </Link>
    </Button>
  );
}
